import { useEffect, useState } from "react";

// Fixed/floating bottom bars (sticky CTAs, chat & WhatsApp bubbles) sit on
// every page and never move — once the footer scrolls into view they'd
// otherwise overlap its content. This reports true while any part of the
// footer is on screen, so callers can hide themselves at that point.
export const useHideNearFooter = () => {
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    const footer = document.getElementById("site-footer");
    if (!footer) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setNearFooter(entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return nearFooter;
};
